import { Pipe, PipeTransform } from '@angular/core';
import {
  isStandardBaseDefinitionRequired,
  SchemaStandardBaseDefinition
} from '@shared/models/schema-property-definition';
import {
  OpportunityRequirement,
  OpportunitySchema
} from '@features/opportunities/modules/core/models/schema-property-definition';

@Pipe({
  name: 'sharedRequirement'
})
export class SharedRequirementPipe implements PipeTransform {
  transform(
    fieldDefinition?:
      | SchemaStandardBaseDefinition
      | OpportunitySchema.BaseDefinition
      | null
  ): boolean {
    if (!fieldDefinition) {
      return false;
    }

    return (
      this.isOpportunitySchemaBaseDefinition(fieldDefinition) ||
      this.isSchemaStandardBaseDefinition(fieldDefinition)
    );
  }

  private isSchemaStandardBaseDefinition(
    input: any
  ): input is SchemaStandardBaseDefinition {
    return 'requirement' in input && isStandardBaseDefinitionRequired(input);
  }

  private isOpportunitySchemaBaseDefinition(
    input: any
  ): input is OpportunitySchema.BaseDefinition {
    return (
      'requirement' in input &&
      OpportunityRequirement.isFundamentallyRequired(input.requirement)
    );
  }
}
